/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_Unit_Mentions_ReceivedInputs */



/**
* | output |
* | --- |
* | "mentions received" |
*
* @param {Perks_Unit_Mentions_ReceivedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_unit_mentions_received = /** @type {((inputs?: Perks_Unit_Mentions_ReceivedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Unit_Mentions_ReceivedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("полученных упоминаний")
	return /** @type {LocalizedString} */ ("mentions received")
});